export default __webpack_public_path__ + "static/media/checkmark.39c7ad49.svg";